import React, { Component } from 'react'
import styles from './NotFound.module.css'

export class NotFound extends Component {
  render () {
    return (
      <div className={styles['not-found']}>
        404 not found
      </div>
    )
  }
}
